import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { Message, MessageAction, MessageFilter, MessageSelector } from "@obg/ngx.core";
import { CoreContentState, MessageCodeFallbackService, TranslationService } from "@obg/ngx.core.content";
import { LoggingService } from "@obg/ngx.global.evo";
import { MessageDisplayService } from "@obg/ngx.ui.core";
import { cloneDeep } from "lodash-es";
import { Observable } from "rxjs";

import { AlertComponent } from "../alert/alert.component";
import { ALERT_DIALOG_ID } from "../alert/alert.const";

import { MessageAlertOptions } from "./message-alert.model";

@Injectable()
export class MessageAlertService extends MessageDisplayService<MatDialogRef<AlertComponent>> {
	constructor(
		messageAction: MessageAction,
		messageCodeFallbackService: MessageCodeFallbackService,
		messageSelector: MessageSelector,
		store: Store<CoreContentState>,
		translationService: TranslationService,
		loggingService: LoggingService,
		private dialog: MatDialog
	) {
		super(messageAction, messageCodeFallbackService, messageSelector, store, translationService, loggingService);
	}

	present(message: Message | Message[], options: MessageAlertOptions): MatDialogRef<AlertComponent> {
		const buttons = cloneDeep(options.buttons);
		let titleText = options.title;
		if (!options.doNotTranslate) {
			if (titleText) {
				titleText = this.getTranslationInstant(super.getMessageKey(options.translationPrefix, titleText));
			}

			if (buttons) {
				for (const button of buttons) {
					button.text = super.getTranslationInstant(super.getMessageKey(undefined, button.text));
				}
			}
		}

		const dialogRef = this.dialog.open(AlertComponent, {
			data: { ...options, title: titleText, buttons, message: super.getMessageText(message, options) },
			id: ALERT_DIALOG_ID,
		});

		if (options.onClose) {
			// eslint-disable-next-line rxjs/no-ignored-subscription
			dialogRef.beforeClosed().subscribe(() => options.onClose!());
		}

		return dialogRef;
	}

	presentOnDispatch(filter: MessageFilter, options?: MessageAlertOptions): Observable<MatDialogRef<AlertComponent>> {
		return super.presentOnDispatch(filter, options);
	}
}
